"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const getCourseWorks_1 = require("./getCourseWorks");
function addCourseWorks(courseWorkDocs) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const batch = app_1.app.firestore.batch();
            const courseWorksRef = app_1.app.firestore.collection(`courseWorks`);
            // filter incomplete coursework based on dueDate
            const skippedCourseWorks = yield filterIncompleteCourseWorks(courseWorksRef, courseWorkDocs);
            // add coursework to google classroom
            const googleClassRoomInfoArr = yield addCourseWorkOnGClass(courseWorkDocs);
            console.log('googleClassRoomInfo for courseWork Docs :', googleClassRoomInfoArr);
            for (const i in courseWorkDocs) {
                if (i !== undefined) {
                    const googleClassRoomInfo = googleClassRoomInfoArr[i].googleClassRoomInfo;
                    // set default values for optional fields
                    const { title, assigneeMode, contentId, courseId, assignorId, domainId, scheduledDate = new Date(0).toISOString(), dueDate = new Date(0).toISOString(), individualStudentsOptions = [], description = '', maxPoints = 0, courseWorkState = identifiers_1.Types.CourseWorkStates.ACTIVE, } = courseWorkDocs[i];
                    const docRef = courseWorksRef.doc();
                    batch.set(docRef, {
                        title,
                        assigneeMode,
                        contentId,
                        courseId,
                        assignorId,
                        domainId,
                        scheduledDate,
                        dueDate,
                        individualStudentsOptions,
                        description,
                        maxPoints,
                        courseWorkState,
                        googleClassRoomInfo
                    });
                    console.log('Document written with ID: ', docRef.id);
                }
            }
            yield batch.commit();
            return { skippedCourseWorks };
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = addCourseWorks;
function filterIncompleteCourseWorks(courseWorksRef, courseWorkDocs) {
    return __awaiter(this, void 0, void 0, function* () {
        const skippedCourseWorks = [];
        // tslint:disable-next-line: forin
        for (const i in courseWorkDocs) {
            const { contentId, courseId } = courseWorkDocs[i];
            const incompleteCourseWorkDocs = yield getCourseWorks_1.default({
                courseId,
                contentId,
                dueDateBefore: new Date().toISOString()
            });
            if (incompleteCourseWorkDocs.length >= 1) {
                // remove element from courseWorkDocs array
                skippedCourseWorks.push(courseWorkDocs[i]);
                courseWorkDocs.splice(parseInt(i, 10), 1);
            }
        }
        return skippedCourseWorks;
    });
}
function addCourseWorkOnGClass(courseWorkDocs) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = 'https://us-central1-omega-rhino-227310.cloudfunctions.net/addCourseWorkToGoogleClassRoom';
        const result = yield fetch(url, {
            method: 'POST',
            body: JSON.stringify(courseWorkDocs),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = yield result.json();
        const googleClassRoomInfoArr = data.data;
        return googleClassRoomInfoArr;
    });
}
//# sourceMappingURL=addCourseWorks.js.map